import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as postsAPI from '../../../../actions/content/posts';
import stateConfig from '../../../../config/state';
import config from '../../../../config/config';
import { resetViewToTopOfPage } from '../../../../utils/utils';


const PROVIDER_REG_SUCCESS_SNIPPET_SLUG = 'provider-registration-success';

function ProviderRegistrationConfirmation({ posts, postsAPI }) {
  const [snippet, setSnippet] = useState(null);

  useEffect(() => {
    resetViewToTopOfPage();
    postsAPI.getSnippetBySlug(PROVIDER_REG_SUCCESS_SNIPPET_SLUG);
  }, [postsAPI]);

  useEffect(() => {
    const post = posts.byId[`${stateConfig.keys.SNIPPET}.${PROVIDER_REG_SUCCESS_SNIPPET_SLUG}`];
    if(post && !post.error) {
      setSnippet(post.content);
    }
  }, [posts.ids, posts.byId]);

  return (
    <div className="ProviderRegistrationSuccess">
      <p className="success-message">You have successfully registered!</p>
      <p className="message">
        <strong>Welcome to the Institute family!</strong> Use the "Explore" menu in the navigation bar to start 
        discovering our current and upcoming events, our library of over {config.libraryHoursOfContent}+ hours of 
        on-demand lectures, and our in-depth courses.
      </p>
      <p className="signature">Your ICC Team</p>
      { snippet !== null &&
        <div className="ProviderRegistrationSuccess-snippet" dangerouslySetInnerHTML={{__html: snippet}} />
      }
    </div>
  );
}

function mapStateToProps(state) {
  return { 
    posts: state.posts
  };
}

function mapDispatchToProps(dispatch) {
  return { 
    postsAPI: bindActionCreators(postsAPI, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProviderRegistrationConfirmation);